module.exports = __webpack_public_path__ + "static/media/download-icon-1.00adc891.png";